import React from 'react';
import Header from 'components/Header.js';
import Main from 'components/Main.js';
import Footer from 'components/Footer.js';
import Sticky from 'react-sticky-el';

const App = () => {
  return (
    <div className="App main-wrapper">
      <Sticky>
        <Header />
      </Sticky>
      <Main />
      <Footer />
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js